// removed by extract-text-webpack-plugin
module.exports = {"drop-target":"_2JBPuKC03trM3VBrML5WHu","drop-target_minimized":"_3h6E3wW3D_bm61ktJoToVa"};